module.exports = __webpack_public_path__ + "static/media/einstein.1c0669ae.jpg";